import React from 'react';
import { useNavigate } from 'react-router-dom';

const ReqDemoAndSignupSection = ({ title, signUpBtn, signUpBtnMobile, reqDemoBtn, bgColor = { background: "linear-gradient(271.26deg,#243256 48.77%,rgba(36, 50, 86, 0.53) 100.67%)" } }) => {
    const navigate = useNavigate();
    const navToDemo = () => navigate("/demo");
    return (
        <section style={bgColor} className='reqDemoAndSignup__Section'>
            <h4>{title}</h4>
            <div>
                <button>{signUpBtn}</button>
                <button>{signUpBtnMobile}</button>
                <button onClick={navToDemo}>{reqDemoBtn}</button>
            </div>
        </section>
    );
};
export default ReqDemoAndSignupSection;